import React, { useContext, useEffect, useState } from 'react'
import { Button, Col, Form, Row, Spinner } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import { add_wallpaper, get_wallpaper_categories_data, update_wallpaper } from '../../../Controller/actions';
import { NewContext } from '../../../Context/NewContext';

import './wallpaperform.css';

export const WallpaperForm = ({ title }) => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { isLoading, setIsLoading, validated, setValidated, updatedData, setUpdatedData } = useContext(NewContext);
  const [wallpapers, setWallpapers] = useState({
    name: state ? state.name : "",
    category: state ? state.category : "",
    // isPremium: state ? state.isPremium == undefined ? false : state.isPremium : false,
    // isActive: state ? state.isActive == undefined ? false : state.isActive : false,
  });
  // console.log(state);
  const [imgObj, setImgObj] = useState({ previewImgWallpaper: state ? state.previewImg : "", backgroundImgWallpaper: state ? state.backgroundImg : "" });
  const [wallpaperCategory, setWallpaperCategory] = useState([]);

  const getCategoryAndTagFunc = async () => {
    try {
      const categoryData = await get_wallpaper_categories_data(1, "", "", { isActive: true });
      if (categoryData.status) {
        setWallpaperCategory(categoryData.data);
      } else {
        toast.error(categoryData.message);
      }
    } catch (error) {
      console.error(error);
    };
  };

  const handleChange = (e) => {
    setUpdatedData({ ...updatedData, [e.target.name]: e.target.value })
    setWallpapers({ ...wallpapers, [e.target.name]: e.target.value });
  };

  const handleFileInput = (e) => {
    if (e.target.files[0].size > 5242880) {
      toast.error(`${e.target.name.charAt(0).toUpperCase() + e.target.name.slice(1)} must less than 5 MB!`);
    } else {
      setImgObj({ ...imgObj, [e.target.name]: URL.createObjectURL(e.target.files[0]) });
      setUpdatedData({ ...updatedData, [e.target.name]: e.target.files[0] })
      setWallpapers({ ...wallpapers, [e.target.name]: e.target.files[0] });
    }
  };

  let handleSwitch = (e) => {
    setUpdatedData({ ...updatedData, [e.target.name]: wallpapers[e.target.name] ? false : true });
    setWallpapers({ ...wallpapers, [e.target.name]: wallpapers[e.target.name] ? false : true });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
      setValidated(true);
      return;
    };
    let createUpdateWallpapers;
    setIsLoading(true);
    if (state) {
      // console.log(wallpapers, "=========state.category._id=============");
      createUpdateWallpapers = await update_wallpaper(updatedData, state._id)
    } else {
      // console.log("==========wallpapers==========", wallpapers);
      createUpdateWallpapers = await add_wallpaper(wallpapers)
    }
    setIsLoading(false);
    if (createUpdateWallpapers) {
      const { message, status } = createUpdateWallpapers;
      if (status) {
        toast.success(message);
        navigate("/wallpaper");
        setWallpapers({
          name: "",
          category: "",
          isPremium: false,
          // isActive: false,
        });
        setImgObj({ previewImgWallpaper: "", backgroundImgWallpaper: "" });
        setUpdatedData({});
        setValidated(false);
      } else {
        toast.error(message);
      };
    }

    // var allFieldDone = [];
    // Object.keys(wallpapers).map(async (fieldName, i) => {
    //   if (fieldName !== 'id') {
    //     if (wallpapers[fieldName].toString().length > 0) {
    //       allFieldDone.push(true);
    //     } else {
    //       allFieldDone.push(false);
    //       toast.error(`${fieldName.charAt(0).toUpperCase() + fieldName.slice(1)} is Requied!`);
    //     }
    //   }
    // });
    // if (!state) {
    //   Object.keys(imgObj).map(async (fieldName, i) => {
    //     if (!imgObj[fieldName]) {
    //       allFieldDone.push(false);
    //       toast.error(`${fieldName.charAt(0).toUpperCase() + fieldName.slice(1)} is Requied!`);
    //       return allFieldDone;
    //     } else {
    //       allFieldDone.push(true);
    //     }
    //   });
    // }

    // const aalFieldDone = allFieldDone.every((val, i, arr) => val === true)
    // if (aalFieldDone) {
    //   let createUpdateWallpapers;
    //   setIsLoading(true);
    //   if (state) {
    //     // console.log(wallpapers, "=========state.category._id=============");
    //     createUpdateWallpapers = await update_wallpaper(wallpapers, state._id)
    //   } else {
    //     // console.log("==========wallpapers==========", wallpapers);
    //     createUpdateWallpapers = await add_wallpaper(wallpapers)
    //   }
    //   setIsLoading(false);
    //   if (createUpdateWallpapers) {
    //     const { message, status } = createUpdateWallpapers;
    //     if (status) {
    //       toast.success(message);
    //       navigate("/wallpaper");
    //       setWallpapers({
    //         id: "",
    //         name: "",
    //         category: "",
    //         isPremium: false,
    //         // isActive: false,
    //       });
    //       setImgObj({ previewImgWallpaper: "", backgroundImgWallpaper: "" });
    //     } else {
    //       toast.error(message);
    //     };
    //   }
    // }
  };

  useEffect(() => {
    getCategoryAndTagFunc();
  }, []);

  useEffect(() => {
    document.title = `Emoji Keyboard | ${title}`;
    setUpdatedData({});
  }, []);

  return (
    <div className='addslider-main p-3'>
      <div className='sliders-header mb-3 d-flex justify-content-between'>
        <h3>{state ? `Edit Wallpaper` : `Add Wallpaper`}</h3>
      </div>
      <Row>
        <Col lg={3} md={4} sm={6} className="mb-3 mx-auto">
          <Row className='flex-column'>
            <Col className='mb-3'>
              <h6 className='mb-1'>Preview: </h6>
              <img className='w-100' src={`${imgObj.previewImgWallpaper ? imgObj.previewImgWallpaper : `../../../assets/images/no-image.png`}`} alt={updatedData.name ? updatedData.name : wallpapers.name} />
            </Col>
            <Col className='mb-3'>
              <h6 className='mb-1'>WallpaperImg: </h6>
              <img className='w-100' src={`${imgObj.backgroundImgWallpaper ? imgObj.backgroundImgWallpaper : `../../../assets/images/no-image.png`}`} alt={updatedData.name ? updatedData.name : wallpapers.name} />
            </Col>
          </Row>
        </Col>
        <Col md={8} lg={9}>
          <Form noValidate validated={validated} onSubmit={handleSubmit} method="POST">
            <Row className='mb-3'>
              <Col lg={6} className="mb-3">
                <Form.Label htmlFor='wallpapers_name' column md={3} sm={4}>Name</Form.Label>
                <Col><Form.Control id='wallpapers_name' type="text" placeholder="Enter name" name='name' onChange={handleChange} value={updatedData.name ? updatedData.name : wallpapers.name} required /></Col>
              </Col>
              <Col lg={6} className="mb-3">
                <Form.Label htmlFor='wallpapers_previewImgWallpaper' column md={3} sm={4}>Preview</Form.Label>
                <Col><Form.Control id='wallpapers_previewImgWallpaper' type="file" accept='image/*' name='previewImgWallpaper' onChange={handleFileInput} required={state ? false : true} /></Col>
              </Col>
              <Col lg={6} className="mb-3">
                <Form.Label htmlFor='wallpapers_backgroundImgWallpaper' column md={3} sm={4}>WallpaperImg</Form.Label>
                <Col><Form.Control id='wallpapers_backgroundImgWallpaper' type="file" accept='image/*' name='backgroundImgWallpaper' onChange={handleFileInput} required={state ? false : true} /></Col>
              </Col>
              <Col lg={6} className="mb-3">
                <Form.Label htmlFor='wallpaper_category' column md={3} sm={4}>Category</Form.Label>
                <Col>
                  <Form.Select id="wallpaper_category" name='category' onChange={handleChange} value={updatedData.category ? updatedData.category : wallpapers.category} required>
                    <option value={""} className='text-muted'>Select Category</option>
                    {wallpaperCategory.map((_ele, i) => <option key={i} value={_ele.name}>{_ele.name}</option>)}
                  </Form.Select>
                </Col>
              </Col>
              {/* <Col lg={12} className="mb-3">
                <Row className='align-items-center'>
                  <Form.Label htmlFor='wallpapers_isPremium' column md={3} sm={4}>Premium</Form.Label>
                  <Col><Form.Check type="switch" id="wallpapers_isPremium" name='isPremium' onChange={handleSwitch} checked={wallpapers.isPremium} role="button" /></Col>
                </Row>
              </Col> */}
              {/* <Col lg={12} className="mb-3">
                                <Row className='align-items-center'>
                                    <Form.Label htmlFor='wallpapers_isActive' column md={3} sm={4}>Active</Form.Label>
                                    <Col><Form.Check type="switch" id="wallpapers_isActive" name='isActive' onChange={handleSwitch} checked={wallpapers.isActive} role="button" /></Col>
                                </Row>
                            </Col> */}
            </Row>
            <Row className='justify-content-end'>
              <Col lg={12}>
                <Col lg={3} md={3} sm={4}></Col>
                <Col>
                  <Button variant="primary" type="submit" className='px-5 me-3' style={{ width: "150px" }}>
                    {isLoading ? <Spinner animation="border" size="sm" /> : state ? `Update` : `Submit`}
                  </Button>
                  {/* <Link to=""> */}
                  <Button variant="danger" className='w-auto px-5' onClick={() => navigate(-1)}>{`Back`}</Button>
                  {/* </Link> */}
                </Col>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </div>
  )
};

WallpaperForm.defaultProps = {
  title: "Wallpaper Form"
};

export default WallpaperForm;